var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "search" } }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("p", { staticClass: "mg mg--b-2 headline-large" }, [
          _vm._v(_vm._s(_vm.$t("common.search")))
        ]),
        _c(
          "div",
          { staticClass: "grid grid--ai-middle mg mg--b-2" },
          [
            _c("ma-input-text", {
              attrs: {
                type: "text",
                name: "sinisterId",
                col: 1,
                icon: "ico-reference-dossier",
                literal: "warrantyRef.sinisterRef.literal",
                value: _vm.sinisterId,
                removeIcon: true
              },
              on: {
                input: function($event) {
                  _vm.sinisterId = $event
                },
                remove: function($event) {
                  ;[
                    (_vm.sinisterId = ""),
                    (_vm.currentPage = 1),
                    _vm.handleSearch()
                  ]
                }
              },
              nativeOn: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleSearchButton.apply(null, arguments)
                }
              }
            }),
            _c("ma-input-text", {
              attrs: {
                type: "text",
                name: "complementaryRef",
                col: 1,
                icon: "ico-reference-dossier",
                literal: "warrantyRef.secondaryRef.literal",
                value: _vm.complementaryRef,
                removeIcon: true
              },
              on: {
                input: function($event) {
                  _vm.complementaryRef = $event
                },
                remove: function($event) {
                  ;[
                    (_vm.complementaryRef = ""),
                    (_vm.currentPage = 1),
                    _vm.handleSearch()
                  ]
                }
              },
              nativeOn: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.handleSearchButton.apply(null, arguments)
                }
              }
            }),
            _c("ma-input-select", {
              attrs: {
                type: "select",
                name: "sinisterStatus",
                col: "1",
                icon: "house",
                literal: "search.status",
                options: _vm.sinisterStatus,
                value: _vm.sinisterStatusValue,
                nullValue: ""
              },
              on: {
                change: function($event) {
                  _vm.sinisterStatusValue = $event
                },
                remove: function($event) {
                  return _vm.handleSearch()
                }
              }
            }),
            _c("span", [
              _c(
                "button",
                {
                  staticClass: "mainYellow",
                  attrs: { "qa-search-btn": "" },
                  on: { click: _vm.handleSearchButton }
                },
                [_vm._v(_vm._s(_vm.$t("actions.search")))]
              )
            ])
          ],
          1
        ),
        _c("p", { staticClass: "mg mg--b-2 headline-medium" }, [
          _vm._v(_vm._s(_vm.$t("common.results")))
        ]),
        _c("table", { staticClass: "table" }, [
          _c("thead", [
            _c("tr", { staticClass: "bg-blueDark" }, [
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("warrantyRef.sinisterRef.literal")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.secondaryRef")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("warrantyProps.zipCode.literal")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("warrantyProps.residentType.literal")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.status")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.gag")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.ren")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.asp")))
                ])
              ]),
              _c("th", [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.createdDate")))
                ])
              ]),
              _c("th", { staticClass: "no--border" }, [
                _c("p", { staticClass: "text-small white" }, [
                  _vm._v(_vm._s(_vm.$t("search.updatedDate")))
                ])
              ]),
              _c("th")
            ])
          ]),
          _vm.hasSinisters
            ? _c(
                "tbody",
                _vm._l(_vm.filteredSinisters, function(sinister) {
                  return _c("tr", [
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.sinister_id))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.complementary_ref))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.zip_code))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.declarant))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.status))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.totals.gag))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.totals.ren))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.totals.asp))
                      ])
                    ]),
                    _c("td", [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.created_date))
                      ])
                    ]),
                    _c("td", { staticClass: "no--border" }, [
                      _c("p", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(sinister.updated_date))
                      ])
                    ]),
                    _c("td", { staticClass: "no--border" }, [
                      _c(
                        "span",
                        { staticClass: "right" },
                        [
                          _c("svgicon", {
                            staticClass: "svg-icon-action",
                            attrs: {
                              "qa-edit-button": "",
                              icon: "edit",
                              height: "18"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleEditClick(
                                  sinister.sinister_id,
                                  sinister.complementary_ref
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                }),
                0
              )
            : _vm._e()
        ]),
        _vm.hasSinisters
          ? _c(
              "div",
              { staticClass: "grid grid--jc-bottom" },
              [
                _c("ma-paginator", {
                  staticClass: "mg mg--t-6",
                  attrs: { current: _vm.currentPage, total: _vm.totalPages },
                  on: {
                    "page:update": _vm.handlePageUpdate,
                    "page:set": _vm.handlePageSet
                  }
                })
              ],
              1
            )
          : _vm._e(),
        !_vm.hasSinisters
          ? _c("ma-empty", {
              attrs: {
                icon: "recherche",
                title: _vm.$t("common.noresults.short"),
                descr: _vm.$t("common.noresults.long")
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }